export const INITIAL_VALUE = 0;
export const INITIAL_INDEX = 0;
export const INCREMENT = 'INCREMENT';
export const DECREMENT = 'DECREMENT';
export const ADD_COUNTER = 'ADD_COUNTER';
export const REMOVE_COUNTER = 'REMOVE_COUNTER';



// WEBPACK FOOTER //
// ./src/utils/constants.js